import ApplicationResource from "./ApplicationResource";
import { Content } from "./Content";
export default class PublicFormResource extends ApplicationResource {
    constructor() {
        super(...arguments);
        this.name = 'Formulaire sans nom';
        this.content = new Content();
    }
    pk() {
        return this.slug;
    }
}
PublicFormResource.resource = '/forms/public/definitions';
//# sourceMappingURL=PublicFormResource.js.map